var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertYellowCircleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.5,
    r: 12,
    fill: "#FFB800"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.8) translate(3, 2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7564 4.98442C10.234 4.19705 11.0835 3.71875 11.9996 3.71875C12.9156 3.71875 13.7651 4.19705 14.2427 4.98442L21.6488 17.3485C22.1144 18.1549 22.1172 19.1478 21.6561 19.9567C21.195 20.7657 20.3393 21.2692 19.3985 21.2795L4.59098 21.2795C3.65988 21.2692 2.80413 20.7657 2.34302 19.9567C1.88191 19.1478 1.88469 18.1549 2.35742 17.3364L9.7564 4.98442ZM3.8633 18.2222C3.70809 18.4909 3.70716 18.8219 3.86087 19.0916C4.01457 19.3612 4.29982 19.5291 4.60059 19.5324L19.3889 19.5325C19.6993 19.5291 19.9846 19.3612 20.1383 19.0916C20.292 18.8219 20.291 18.4909 20.1429 18.2342L12.7465 5.88636C12.5881 5.62529 12.3049 5.46585 11.9996 5.46585C11.6949 5.46585 11.4123 5.62459 11.2537 5.88464L3.8633 18.2222ZM11.126 9.92336C11.126 9.44091 11.5171 9.04981 11.9996 9.04981C12.482 9.04981 12.8731 9.44091 12.8731 9.92336V13.4176C12.8731 13.9 12.482 14.2911 11.9996 14.2911C11.5171 14.2911 11.126 13.9 11.126 13.4176V9.92336ZM11.9996 17.7853C12.482 17.7853 12.8731 17.3942 12.8731 16.9118C12.8731 16.4293 12.482 16.0382 11.9996 16.0382C11.5171 16.0382 11.126 16.4293 11.126 16.9118C11.126 17.3942 11.5171 17.7853 11.9996 17.7853Z",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertYellowCircleIcon);
export default __webpack_public_path__ + "static/media/alertYellowCircleIcon.60b9e46ccdee85f3b8a385e838b97d54.svg";
export { ForwardRef as ReactComponent };